import type { SVGProps } from "react";

const BackArrowIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.72 22c-.356 0-.657-.135-.894-.383l-8.374-8.58C2.151 12.733 2 12.395 2 12q0-.135.027-.26a1.45 1.45 0 0 1 .425-.789l8.374-8.568c.237-.248.538-.383.893-.383C12.43 2 13 2.586 13 3.33c0 .361-.15.71-.398.97l-6.32 6.45H20.75a1.25 1.25 0 1 1 0 2.5H6.3l6.302 6.45c.247.26.398.598.398.97 0 .744-.57 1.33-1.28 1.33"
            clipRule="evenodd"
        />
    </svg>
);
export default BackArrowIcon;
